module.exports = __webpack_public_path__ + "static/img/heading.0b1ad477.png";